import { Card, CardContent, Grid, Typography } from '@mui/material';

interface SummaryCardData {
  title: string;
  value: string;
  color?: string;
}

interface SummaryCardProps {
  cards: SummaryCardData[];
}

export const SummaryCard: React.FC<SummaryCardProps> = ({ cards }) => (
  <Grid container spacing={2}>
    {cards.map((card, idx) => (
      <Grid item xs={12} sm={6} key={idx}>
        <Card>
          <CardContent>
            <Typography variant='caption' color='text.secondary'>
              {card.title}
            </Typography>
            <Typography
              variant='h5'
              sx={{ color: card.color || 'primary.main', fontWeight: 600 }}
            >
              {card.value}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
);
